import { Avatar, Box } from '@mui/material';
import { useWeb3React } from '@web3-react/core';
import React, { CSSProperties } from 'react';

import { networkConfigs } from '../../../../constants';
import { ProtocolName } from '../../../../constants/protocolNames';
import { useAppSelector } from '../../../../store';
import { NoLogoURI, RouteModalDivider } from '../../../icons';
import { Modal, ModalHeaderType } from '../../Modal';
import { OneInchRoutes } from '../OneInchRoutes';

interface RouteModalProps {
  protocols: any;
  isOpen: boolean;
  goBack: () => void;
  totalRouteSteps: number;
}

const RouteModal = ({ protocols, isOpen, goBack, totalRouteSteps }: RouteModalProps) => {
  const { chainId } = useWeb3React();
  const INPUT = useAppSelector((state) => state.swap.INPUT);
  const OUTPUT = useAppSelector((state) => state.swap.OUTPUT);
  const tokens = useAppSelector((state) => state.tokens.tokens);
  const selectedProtocol = useAppSelector((state) => state.swap.selectedProtocol);
  const protocolLength = protocols?.length;

  const routesRenders: { [protocolName: string]: any } = {
    [ProtocolName.ONE_INCH]: OneInchRoutes({ protocols, tokens, totalRouteSteps }),
  };

  const routeWindowHeightOptions: { [numberRouters: number]: CSSProperties['height'] } = {
    1: '338px',
    2: '430px',
    3: '523px',
  };

  const routeWindowHeight =
    (chainId && routeWindowHeightOptions[networkConfigs[chainId]?.supportedProtocols.length]) ||
    routeWindowHeightOptions[1];

  return (
    <Modal headerType={ModalHeaderType.Route} isOpen={isOpen} goBack={goBack}>
      <Box
        sx={{
          position: 'absolute',
          top: 50,
          display: 'flex',
          justifyContent: 'center',
          width: 'inherit',
          padding: '18px 0',
        }}>
        <Avatar
          alt={tokens[INPUT]?.symbol}
          src={tokens[INPUT]?.logoURI}
          sx={{ position: 'absolute', width: 32, height: 32, backgroundColor: 'transparent' }}>
          <NoLogoURI />
        </Avatar>
        <RouteModalDivider styles={{ bottom: -30 }} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: 115,
          left: 0,
          display: 'flex',
          justifyContent: `${protocolLength < 2 ? 'center' : 'flex-start'}`,
          overflow: 'auto',
          borderLeft: '15px solid',
          borderRight: '15px solid',
          borderColor: 'widget.bg-main',
          boxSizing: 'border-box',
          width: 'inherit',
          height: routeWindowHeight,
          padding: '0 10px',
        }}>
        {routesRenders[selectedProtocol]}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          width: 'inherit',
          padding: '18px 0 28px',
        }}>
        <RouteModalDivider styles={{ top: -28 }} />
        <Avatar
          alt={tokens[OUTPUT]?.symbol}
          src={tokens[OUTPUT]?.logoURI}
          sx={{ position: 'absolute', top: -12, width: 32, height: 32, backgroundColor: 'transparent' }}>
          <NoLogoURI />
        </Avatar>
      </Box>
    </Modal>
  );
};

export default RouteModal;
